<template>
<div class="mu-calendar">
  <div class="mu-calendar-container">
    <div class="mu-calendar-monthday-container">
      <calendar-toolbar :slideType="slideType" :displayDates="displayDates" :dateTimeFormat="dateTimeFormat" />
      <div class="mu-calendar-week">
        <span class="mu-calendar-week-day" v-for="weekText, index in weekTexts" :key="index">{{weekText}}</span>
      </div>
      <div class="mu-calendar-monthday" style="height: 260px">
        <transition :name="'mu-calendar-slide-' + slideType" v-for="displayDate, index in displayDates" :key="index">
          <div class="mu-calendar-monthday-slide" :key="displayDate.getTime()" >
            <calendar-month @selected="handleSelected" :displayDate="displayDate" :firstDayOfWeek="firstDayOfWeek" :selectedDate="selectedDate" :multiple="multiple" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import calendarToolbar from './calendarToolbar'
import calendarMonth from './calendarMonth'
import * as dateUtils from './dateUtils'
export default {
  props: {
    dateTimeFormat: {
      type: Object,
      default () {
        return dateUtils.dateTimeFormat
      }
    },
    firstDayOfWeek: {
      type: Number,
      default: 1
    },
    initialDate: {
      type: Date,
      default () {
        return new Date()
      }
    },
    multiple: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    const displayDate = dateUtils.cloneDate(this.initialDate)
    displayDate.setDate(1)
    return {
      weekTexts: this.dateTimeFormat.getWeekDayArray(this.firstDayOfWeek),
      displayDates: [displayDate],
      selectedDate: this.initialDate,
      slideType: 'next'
    }
  },
  methods: {
    handleSelected (date) {
      this.$emit('selected', date)
    }
  },
  watch: {
    initialDate (val) {
      this.selectedDate = val
    }
  },
  components: {
    'calendar-toolbar': calendarToolbar,
    'calendar-month': calendarMonth
  }
}
</script>
<style>
  .mu-calendar {
    background-color: #fff;
  }
  .mu-calendar-monthday-container  {
    padding: 0
  }
  .mu-calendar-week {
    background-color: #ccc;
    line-height: 19.2px
  }
</style>


// WEBPACK FOOTER //
// src/components/NewDatePicker/calendar.vue